import { CreditCard as r } from "./credit-card.js";
import { CreditCard2 as o } from "./credit-card-2.js";
import { CreditCardCheck as i } from "./credit-check.js";
import { CreditCardLock as m } from "./credit-lock.js";
import { Cash as a } from "./cash.js";
import { Giftcard as t } from "./giftcard.js";
import { Giftcard2 as p } from "./giftcard-2.js";
import { Issuing as n } from "./issuing.js";
import { StackOfCreditCards2 as f } from "./stack-of-credit-cards-2.js";
import { StackOfCreditCards as e } from "./stack-of-credit-cards.js";
import { InstantCardPayout as l } from "./instant-card-payout.js";
import { Payout as s } from "./payout.js";
import { FastPayout as d } from "./fast-payout.js";
import { CashStack as C } from "./cash-stack.js";
import { Wallet as h } from "./wallet.js";
import { Graph as c } from "./graph.js";
import { Revenue as u } from "./revenue.js";
import { Graph2 as g } from "./graph-2.js";
import { PricingCards as S } from "./pricing-cards.js";
import { CreditCardChip as D } from "./credit-card-chip.js";
import { Installments as P } from "./installments.js";
import { MagnetStripSwipe as R } from "./magnet-strip-swipe.js";
import { CashBack as K } from "./cash-back.js";
import { Passport as y } from "./passport.js";
import { Euro as w } from "./euro.js";
import { CzechKoruna as k } from "./czech-koruna.js";
import { IcelandicKrona as I } from "./icelandic-krona.js";
import { DanishKrone as M } from "./danish-krone.js";
import { NorwegianKrone as b } from "./norwegian-krone.js";
import { SwedishKrona as F } from "./swedish-krona.js";
import { PolishZloty as G } from "./polish-zloty.js";
import { RussianRuble as z } from "./russian-ruble.js";
import { SwissFranc as B } from "./swiss-franc.js";
import { WestAfricanCfaFranc as N } from "./west-african-cfa-franc.js";
import { PoundSterling as A } from "./pound-sterling.js";
import { HungarianForint as O } from "./hungarian-forint.js";
import { ChineseYuanRenminbi as U } from "./chinese-yuan-renminbi.js";
import { HongKongDollar as W } from "./hong-kong-dollar.js";
import { IndianRupee as Z } from "./indian-rupee.js";
import { IndonesianRupiah as x } from "./indonesian-rupiah.js";
import { JapaneseYen as E } from "./japanese-yen.js";
import { MalaysianRinggit as H } from "./malaysian-ringgit.js";
import { NewZealandDollar as T } from "./new-zealand-dollar.js";
import { PhilippinePeso as Y } from "./philippine-peso.js";
import { SingaporeDollar as v } from "./singapore-dollar.js";
import { SouthKoreanWon as J } from "./south-korean-won.js";
import { ThaiBaht as L } from "./thai-baht.js";
import { VietnameseDong as Q } from "./vietnamese-dong.js";
import { BrazilianReal as V } from "./brazilian-real.js";
import { MexicanPeso as j } from "./mexican-peso.js";
import { UnitedStatesDollar as q } from "./united-states-dollar.js";
import { CanadianDollar as X } from "./canadian-dollar.js";
import { AustralianDollar as _ } from "./australian-dollar.js";
import { GhanaianCedi as $ } from "./ghanaian-cedi.js";
import { TanzanianShilling as rr } from "./tanzanian-shilling.js";
import { UgandanShilling as or } from "./ugandan-shilling.js";
import { KenyanShilling as ir } from "./kenyan-shilling.js";
import { ZambianKwacha as mr } from "./zambian-kwacha.js";
import { MozambicanMetical as ar } from "./mozambican-metical.js";
import { MoroccanDirham as tr } from "./moroccan-dirham.js";
import { NigerianNaira as pr } from "./nigerian-naira.js";
import { BahrainiDinar as nr } from "./bahraini-dinar.js";
import { EgyptianPound as fr } from "./egyptian-pound.js";
import { KuwaitiDinar as er } from "./kuwaiti-dinar.js";
import { OmaniRial as lr } from "./omani-rial.js";
import { QatariRiyal as sr } from "./qatari-riyal.js";
import { SaudiArabianRiyal as dr } from "./saudi-arabian-riyal.js";
import { UaeDirham as Cr } from "./uae-dirham.js";
const Fo = {
  CreditCard: r,
  CreditCard2: o,
  CreditCardCheck: i,
  CreditCardLock: m,
  Cash: a,
  Giftcard: t,
  Giftcard2: p,
  Issuing: n,
  StackOfCreditCards2: f,
  StackOfCreditCards: e,
  InstantCardPayout: l,
  Payout: s,
  FastPayout: d,
  CashStack: C,
  Wallet: h,
  Graph: c,
  Revenue: u,
  Graph2: g,
  PricingCards: S,
  CreditCardChip: D,
  Installments: P,
  MagnetStripSwipe: R,
  CashBack: K,
  Passport: y,
  Euro: w,
  CzechKoruna: k,
  IcelandicKrona: I,
  DanishKrone: M,
  NorwegianKrone: b,
  SwedishKrona: F,
  PolishZloty: G,
  RussianRuble: z,
  SwissFranc: B,
  WestAfricanCfaFranc: N,
  PoundSterling: A,
  HungarianForint: O,
  ChineseYuanRenminbi: U,
  HongKongDollar: W,
  IndianRupee: Z,
  IndonesianRupiah: x,
  JapaneseYen: E,
  MalaysianRinggit: H,
  NewZealandDollar: T,
  PhilippinePeso: Y,
  SingaporeDollar: v,
  SouthKoreanWon: J,
  ThaiBaht: L,
  VietnameseDong: Q,
  BrazilianReal: V,
  MexicanPeso: j,
  UnitedStatesDollar: q,
  CanadianDollar: X,
  AustralianDollar: _,
  GhanaianCedi: $,
  TanzanianShilling: rr,
  UgandanShilling: or,
  KenyanShilling: ir,
  ZambianKwacha: mr,
  MozambicanMetical: ar,
  MoroccanDirham: tr,
  NigerianNaira: pr,
  BahrainiDinar: nr,
  EgyptianPound: fr,
  KuwaitiDinar: er,
  OmaniRial: lr,
  QatariRiyal: sr,
  SaudiArabianRiyal: dr,
  UaeDirham: Cr
};
export {
  Fo as Financial
};
